import React from 'react'
import { Alert, AlertIcon, Flex } from '@chakra-ui/react'
import { useExtension } from '@hooks'

const ProgressNotesExplanation = () => {
  const { settings } = useExtension()
  return (
    <Alert
      status="info"
      borderRadius="md"
      colorScheme="#F7F8FE"
      p="small"
      my="small"
      mb={{ base: '28', md: '4' }}
    >
      <AlertIcon color="primary" marginRight="sm" />
      <Flex flexDirection="column">
        {`Notes are auto-generated using AI and should always be reviewed and, if needed, edited for accuracy before saving to the ${settings?.patientReference?.toLocaleLowerCase() ||
          'client’s'} record in your EHR.`}
      </Flex>
    </Alert>
  )
}

export default ProgressNotesExplanation
